module.exports = __webpack_public_path__ + "img/883-cb9c55.png";